<template>
  <div class="prezzo">
    <p class="prezzo_finale">{{ prezzo }}* {{ valuta }}**</p>
    <p class="nota_prezzo note">{{ conversion_nota }} {{ conversion }}</p>
    <p class="nota_prezzo note_2" v-if="prezzo_include_exist">
      <span class="underline_note"> *{{ prezzo_include_nota }} </span>
      {{ prezzo_include }}
    </p>
    <p class="nota_prezzo note_3" v-if="prezzo_noninclude_exist">
      <span class="underline_note"> {{ prezzo_noninclude_nota }} </span>
      {{ prezzo_noninclude }}
    </p>
    <p class="nota_prezzo note_4" v-if="servizi_extra_exist">
      <span class="underline_note"> {{ servizi_extra_nota }} </span>
      {{ servizi_extra }}
    </p>
    <p class="nota_prezzo note_5" v-if="Spese_trasporto_exist">
      <span class="underline_note">{{ Spese_trasporto_nota }} </span>
      {{ Spese_trasporto }}
    </p>
  </div>
</template>
<script>
import get_json_product from "../classes/class_get_json_product";
import class_check_language from "../classes/class_check_language";

export default {
  name: "prezzo",
  data: () => ({
    conversion_nota: "",
    conversion:
      "** Il valore sarà convertito in valuta locale al cambio del giorno ",
    prezzo_include: "",
    prezzo_include_exist: false,
    prezzo_noninclude: "",
    prezzo_noninclude_exist: false,
    servizi_extra: "",
    servizi_extra_exist: false,
    Nota_valuta: "",
    Nota_valuta_exist: false,
    Nota_valuta_nota: "",
    Spese_trasporto: "",
    Spese_trasporto_exist: false,
    Spese_trasporto_nota: "Tempi di consegna",
    prezzo_include_nota: "Il prezzo include",
    prezzo_noninclude_nota: "Il prezzo non include",
    servizi_extra_nota: "Servizi Extra",
  }),
  mounted() {
    let t = new class_check_language();
    if (!t.is_italian()) {
      (this.conversion =
        "** Value will be converted to local currency at the exchange rate of the day."),
        (this.Spese_trasporto_nota = "Delivery time");
      this.prezzo_include_nota = "The price includes";
      this.prezzo_noninclude_nota = "The price does not include";
      this.servizi_extra_nota = "Extra Services";
    }
    let y = new get_json_product();
    //    let cl = this.$store.state.product.codice_listino;
    y.GET_NOTE_PROMISE().then((data) => {
      try {
        let result = data.filter((listino) => {
          return listino.Codice == window.descrizione.codice_listino;
        });
        if (result[0].Prezzo_include !== undefined) {
          this.prezzo_include = result[0].Prezzo_include;
          this.prezzo_include_exist = true;
        }
        if (result[0].Prezzo_non_include !== undefined) {
          this.prezzo_noninclude_exist = true;
          this.prezzo_noninclude = result[0].Prezzo_non_include;
        }
        if (result[0].Servizi_extra !== undefined) {
          this.servizi_extra_exist = true;
          this.servizi_extra = result[0].servizi_extra;
        }
        if (result[0].Nota_valuta !== undefined) {
          this.Nota_valuta_exist = true;
          this.Nota_valuta = result[0].Nota_valuta;
        }
        if (result[0].Spese_trasporto !== undefined) {
          this.Spese_trasporto_exist = true;
          this.Spese_trasporto = result[0].Spese_trasporto;
        }
      } catch (error) {
        console.info("error prezzo.vue", error);
      }
    });
  },
  computed: {
    prezzo() {
      let q = this.$store.state.product_store.QUANTITA_RICHIESTA;
      let n = parseFloat(
        parseFloat(this.$store.state.product_store.PREZZO) * parseFloat(q)
      ).toFixed(2);
      let c = n.toString().replace(".", ",");
      const formatted = c.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      return formatted;
    },
    prezzi() {
      return this.$store.state.products.prezzi;
    },
    debug() {
      return this.$store.state.products.debug;
    },
    valuta() {
      //   PREZZO LISTINO CORRENTE
      let valuta = "€";
      //   LISTINO DOLLARI CANADA
      if (this.$store.state.product.codice_listino == "6") {
        valuta = "c$";
      }
      //   LISTINO DOLLARI
      if (this.$store.state.product.codice_listino == "7") {
        valuta = "$";
      }
      //   LISTINO FEDERAZIONE RUSSA
      if (this.$store.state.product.codice_listino == "100") {
        valuta = "₽";
      }
      //   LISTINO AUSTRALIA
      if (this.$store.state.product.codice_listino == "101") {
        valuta = "A$";
      }
      //   VM PRICE LIST ESTONIA
      if (this.$store.state.product.codice_listino == "102") {
        valuta = "kr";
      }
      //   VM PRICE LIST MESSICO
      if (this.$store.state.product.codice_listino == "103") {
        valuta = "Mex$";
      }
      //   VM PRICE LIST UCRAINA
      if (this.$store.state.product.codice_listino == "106") {
        valuta = "UAH";
      }
      //   VM PRICE LIST BIELORUSSIA
      if (this.$store.state.product.codice_listino == "107") {
        valuta = "Br";
      }
      //   VM PRICE LIST FINLAND
      //   EURO
      //   this.$store.state.product.codice_listino == "108")
      //   LISTINO INGHITERRA
      if (this.$store.state.product.codice_listino == "109") {
        valuta = "£";
      }
      //   VM PRICE LIST IRLAND
      //   EURO
      //   this.$store.state.product.codice_listino == "110")
      //   LISTINO BRASILE
      if (this.$store.state.product.codice_listino == "111") {
        valuta = "R$";
      }
      //   VM PRICE LIST  NORVEGIA
      if (this.$store.state.product.codice_listino == "114") {
        valuta = "NOK";
      }
      //   VM PRICE LIST  SVEZIA
      if (this.$store.state.product.codice_listino == "115") {
        valuta = "SEK";
      }
      //   VM PRICE LIST  GIAPPONE
      if (this.$store.state.product.codice_listino == "116") {
        valuta = "¥";
      }
      //   VM PRICE LIST UK ?? Doppione?
      if (this.$store.state.product.codice_listino == "117") {
        valuta = "£";
      }
      //   VM PRICE LIST BULGARIA
      if (this.$store.state.product.codice_listino == "118") {
        valuta = "лв";
      }
      //   VM PRICE LIST SINGAPORE
      if (this.$store.state.product.codice_listino == "119") {
        valuta = "S$";
      }
      //   VM PRICE LIST CIPRO
      //   EURO
      //   this.$store.state.product.codice_listino == "120")
      //   VM PRICE LIST GRECIA
      //   EURO
      //   this.$store.state.product.codice_listino == "121")
      //   VM PRICE LIST SINGAPORE
      if (this.$store.state.product.codice_listino == "122") {
        valuta = "֏";
      }
      //   VM PRICE LIST SINGAPORE
      if (this.$store.state.product.codice_listino == "123") {
        valuta = "฿";
      }

      return valuta;
    },
  },
};
</script>
<style scoped>
.underline_note {
  text-decoration: underline;
  font-size: 12px;
}
.nota_prezzo {
  font-size: 12px;
  margin-bottom: 0px;
  width: 80vw;
}
</style>
